/* -----------------UI--------------- */
import { Dialog, type DialogProps } from "@mui/material";
import type { SyntheticEvent } from "react";
import { IconButton } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	visible: boolean;
	handleClose?: () => void;
	maxWidth?: DialogProps["maxWidth"];
	children?: React.ReactNode;
	showCloseButton?: boolean;
	height?: number | string;
	minHeight?: number | string | `${number}%`;
};
export const DialogWrapperWeb = ({
	visible,
	handleClose,
	children,
	maxWidth,
	showCloseButton = true,
	height,
	minHeight = "150px",
}: Props) => {
	const theme = useAppTheme();

	return (
		<Dialog
			open={visible}
			fullWidth
			onClose={(event: SyntheticEvent) => {
				event.stopPropagation();
				handleClose?.();
			}}
			maxWidth={maxWidth || "sm"}
			PaperProps={{
				sx: {
					borderRadius: theme.roundness * 4,
					position: "relative",
					height: height || "auto",
					minHeight,
					backgroundImage: "none",
				},
			}}
		>
			{showCloseButton && (
				<IconButton
					icon={"close"}
					onPress={handleClose}
					style={{
						position: "absolute",
						right: 8,
						top: 6,
						zIndex: 1000,
					}}
				/>
			)}
			{/* biome-ignore lint/suspicious/noExplicitAny: children prop type compatibility */}
			{children as any}
		</Dialog>
	);
};
